import CheckInLogoNew from '../logo/gte_logo.png';

/** Port of `components/utilComponents/notFound.jsx`. DOM and class names unchanged. */
export function NotFoundPage(): JSX.Element {
  return (
    <>
      <div className="ch-header">
        {/* `alt` on a div is not valid HTML, but React renders unknown attributes
            through to the DOM, so it is present in the original's markup. Spread past
            the JSX typings rather than dropping it — a CSS attribute selector could
            depend on it, and App.css is carried byte-identical. */}
        <div tabIndex={0} className="app-logo" title="CheckIn" {...{ alt: 'CheckIn Logo' }}>
          <img src={CheckInLogoNew} alt="CheckIn" />
        </div>
        <div className="logged-user-info"></div>
      </div>
      <div className="center_nf">
        <div className="row inline-row">
          <div className="f04">404: The page you requested could not be found.</div>
          <div className="pnf">
            <a href="/" className="pnfA">
              Home
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
